import { useEffect } from 'react';

import { useWindowDimensions } from 'react-native';

import { Loader } from 'components/loader';
import { IWebviewPropsWeb } from 'pages/campaigns/types';
import { theme } from 'styles/configure-theme';

import { listenToMessagesFromOrigin } from './listeners';

export const WebView = ({
  listenForMessage,
  externalUrl,
  onLoadEnd,
  iframeLoaded,
  webViewRef,
  loadingMessage,
  queryParam,
  backgroundColor,
}: IWebviewPropsWeb) => {
  const { width } = useWindowDimensions();

  useEffect(() => {
    if (iframeLoaded) {
      listenToMessagesFromOrigin(listenForMessage, new URL(externalUrl).origin);
    }
  }, [externalUrl, iframeLoaded, listenForMessage, webViewRef]);

  return (
    <div style={{ height: 'calc(var(--real-vh, 1vh) * 100)' }}>
      {!iframeLoaded && <Loader copy={loadingMessage} loading={!iframeLoaded} />}
      <iframe
        title="external-campaign"
        src={`${externalUrl}${queryParam}`}
        onLoad={onLoadEnd}
        ref={webViewRef}
        height={window.innerHeight}
        allow="clipboard-write; web-share"
        style={{
          border: 0,
          backgroundColor: backgroundColor || theme.token('background-default'),
          height: window.innerHeight,
          width,
        }}
      ></iframe>
    </div>
  );
};
